import * as React from 'react';
import * as SliderPrimitive from '@radix-ui/react-slider';

import { cn } from '@/lib/utils';
import { ClassNameValue } from 'tailwind-merge';

const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root> & {
    trackWrapperClass?: ClassNameValue;
    rangeWrapperClass?: ClassNameValue;
    roundWrapperClass?: ClassNameValue;
  }
>(({ className, trackWrapperClass, rangeWrapperClass, roundWrapperClass, ...props }, ref) => (
  <SliderPrimitive.Root ref={ref} className={cn('relative flex w-full touch-none select-none items-center', className)} {...props}>
    <SliderPrimitive.Track
      className={cn('relative h-1.5 w-full grow overflow-hidden rounded-full bg-zinc-900/20 dark:bg-zinc-50/20', trackWrapperClass)}
    >
      <SliderPrimitive.Range className={cn('absolute h-full ', rangeWrapperClass)} />
    </SliderPrimitive.Track>
    <SliderPrimitive.Thumb
      className={cn(
        'block h-4 w-4 rounded-full border border-zinc-200 border-zinc-900/50 bg-white shadow transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-zinc-950 disabled:pointer-events-none disabled:opacity-50 dark:border-zinc-200 dark:border-zinc-50/50 dark:bg-zinc-950 dark:focus-visible:ring-zinc-300',
        roundWrapperClass,
      )}
    />
  </SliderPrimitive.Root>
));
Slider.displayName = SliderPrimitive.Root.displayName;

export { Slider };
